export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';
export const WARNING = 'WARNING';
export const ACTIVE = 'Activo';
export const INACTIVE = 'Inactivo';
export const INVITED = 'Invitado';
export const ACTIVE_STATUS = 'Active';
export const INACTIVE_STATUS = 'Inactive';
export const INVITED_STATUS = 'Invited';
export const SUPER_ADMIN = 'superAdmin';
export const NOT_RESULT_FOUND = 'No se encontraron resultados';
export const TITLE_LEVEL = 1;
